module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point1_3-3319a7ce3246e6dd63bec967b9d2c6c9.jpg";